import React from "react";
import DynamicGrid from "../DynamicGrid";

const Settings = {
	SortColumn: "full_name",
	ShowGlobalFilter: true,
};

const config = [
	{
		header: "Mechanic",
		columnName: "full_name",
		typeCode: "S",
		visible: true,
	},
	{
		header: "Building",
		columnName: "building_name",
		typeCode: "S",
		visible: true,
	},
	{
		header: "Check In/Out Date",
		columnName: "check_in_date",
		typeCode: "DT",
		visible: true,
	},
];

export function CheckedInMechanics() {
	const [mechs, setMechs] = React.useState([]);

	if (mechs.length === 0)
		fetch("User/GetCheckedInUsers")
			.then((x) => x.json())
			.then((x) => {
				setMechs(x);
			});

	return (
		<div style={{ backgroundColor: "#ebebeb", padding: "4px", flex: 1, display: "flex", flexDirection: "column", maxHeight: "100%" }}>
			<div style={{ flex: "1 1 100%", display: "flex", overflowY: "auto" }}>
				<DynamicGrid OnRowClick={undefined} ShowTicketTypeFilter={false} Title="Checked-In Mechanics" Configuration={config} DataSet={mechs} Settings={Settings} />
			</div>
		</div>
	);
}
